import useGoals from '@/composables/goal/goals';
import { RESULT } from 'shared/api/query/constants';
import { goalById } from '@/api/query/nebula/goal';
import { logCatch } from '@/lib/logger/logger';
import { updateListForGoal } from '@/api/query/nebula/update';

export default function useTileSingleGoalFetcher() {
  const goalsSvc = useGoals();

  const getGoalById = (id) => goalsSvc.getGoals({
    queries: [
      ...goalById(id, RESULT),
      ...updateListForGoal(id, 'updates'),
    ],
  }).then((data) => ({
    goal: data[RESULT][0],
    updates: data.updates,
  })).catch(logCatch(() => {
    throw new Error('failed to query goal with id:', id);
  }));

  return { getGoalById };
}
